var render = function () {
  var _vm$awb;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tracking"
  }, [_c('div', {
    staticClass: "flex justify-between items-end mb-6 mdmax:flex-col mdmax:gap-4"
  }, [_c('div', {
    staticClass: "w-80 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('tracking.searchLabel')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": _vm.$t('tracking.searchPlaceholder')
    },
    on: {
      "enter": function enter($event) {
        return _vm.track();
      }
    },
    model: {
      value: _vm.awbNumber,
      callback: function callback($$v) {
        _vm.awbNumber = $$v;
      },
      expression: "awbNumber"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)]), _vm.isDataFound ? _c('div', {
    staticClass: "mdmax:w-full"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Lihat Pesanan",
      "size": _vm.isMobile ? 'full' : 'regular',
      "linkType": "internal",
      "url": "/order/detail/".concat(_vm.awb.order_id)
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "bg-white flex justify-center items-center shadow-md"
  }, [!_vm.isDataFound && !_vm.error ? _c('p', {
    staticClass: "text-base font-bold my-32 mdmax:px-6 mdmax:text-center"
  }, [_vm._v(_vm._s(_vm.$t('tracking.dataNotFound')))]) : _vm._e(), _vm.error ? _c('div', {
    staticClass: "my-32"
  }, [_c('p', {
    staticClass: "text-base font-bold text-center"
  }, [_vm._v(_vm._s(_vm.$t('tracking.invalidAWB')))]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-center"
  }, [_vm._v(_vm._s(_vm.$t('tracking.inputOtherAWB')))])]) : _vm._e(), _vm.isDataFound ? _c('div', {
    staticClass: "flex w-full border mdmax:flex-col"
  }, [_c('div', {
    staticClass: "bg-neutral-200 w-2/5 py-8 px-16 mdmax:w-full mdmax:px-8"
  }, [_c('div', {
    staticClass: "mb-8 pb-3 shadow-border-b"
  }, [_c('label', {
    staticClass: "text-xs text-neutral-500 mb-1"
  }, [_vm._v(_vm._s(_vm.$t('tracking.logisticName')))]), _c('p', [_vm._v(_vm._s(_vm.awb.service_name))])]), _c('div', {
    staticClass: "mb-8 pb-3 shadow-border-b"
  }, [_c('label', {
    staticClass: "text-xs text-neutral-500 mb-1"
  }, [_vm._v(_vm._s(_vm.$t('tracking.service')))]), _c('p', [_vm._v(_vm._s(_vm.awb.service_package_name))])]), _c('div', {
    staticClass: "mb-8 pb-3 shadow-border-b"
  }, [_c('label', {
    staticClass: "text-xs text-neutral-500 mb-1"
  }, [_vm._v(_vm._s(_vm.$t('tracking.AWB')))]), _c('p', [_vm._v(_vm._s(_vm.awb.awb))])]), _c('div', {
    staticClass: "mb-8 pb-3 shadow-border-b"
  }, [_c('label', {
    staticClass: "text-xs text-neutral-500 mb-1"
  }, [_vm._v(_vm._s(_vm.$t('tracking.deliveredDate')))]), _c('p', [_vm._v(_vm._s(_vm.awb.delivery_time_display))])]), _c('div', {
    staticClass: "mb-8 pb-3 shadow-border-b"
  }, [_c('label', {
    staticClass: "text-xs text-neutral-500 mb-1"
  }, [_vm._v(_vm._s(_vm.$t('tracking.sender')))]), _c('p', [_vm._v(_vm._s(_vm.awb.sender.name))]), _c('p', {
    staticClass: "text-xs"
  }, [_vm._v(_vm._s(_vm.awb.sender.location_name))])]), _c('div', {
    staticClass: " pb-3 shadow-border-b"
  }, [_c('label', {
    staticClass: "text-xs text-neutral-500 mb-1"
  }, [_vm._v(_vm._s(_vm.$t('tracking.receiver')))]), _c('p', [_vm._v(_vm._s(_vm.awb.receiver.name))]), _c('p', {
    staticClass: "text-xs"
  }, [_vm._v(_vm._s(_vm.awb.receiver.location_name))])])]), _c('div', {
    staticClass: "w-3/5 p-8 mdmax:w-full"
  }, _vm._l((_vm$awb = _vm.awb) === null || _vm$awb === void 0 ? void 0 : _vm$awb.tracking_infos, function (tracking, index) {
    return _c('div', {
      key: 'tracking' + index,
      staticClass: "flex gap-5"
    }, [_c('div', {
      staticClass: "line relative"
    }, [_c('span', {
      staticClass: "inline-block w-5 h-5 rounded-full  border-4  relative z-1",
      class: index === 0 ? 'bg-primary-500 border-primary-100' : 'bg-neutral-500 border-neutral-300'
    }), _c('span', {
      staticClass: "absolute border-dashed border-neutral-300 h-full w-px border left-1/2 transform -translate-x-1/2 top-0 z-0"
    })]), _c('div', {
      staticClass: "status mb-6"
    }, [_c('p', {
      staticClass: "text-sm mb-1"
    }, [_vm._v(_vm._s(tracking.time_display))]), _c('p', {
      staticClass: "text-neutral-700 mb-1"
    }, [_vm._v(_vm._s(tracking.main_info))]), _c('p', {
      staticClass: "text-sm"
    }, [_vm._v(_vm._s(tracking.additional_info))])])]);
  }), 0)]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }